import {
	Box,
	Button,
	Card,
	CardContent,
	CardHeader,
	Divider,
	Grid,
	LinearProgress, makeStyles, TextField,
	MenuItem,
	Typography
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useActions, useValues } from 'kea';
import organisationlogic from 'src/store/organisation';
// import { keycloak } from '../../../config/keycloak';


//TODO clean styles
const useStyles = makeStyles(() => ({
	root: {
		// maxWidth:1000
	}
}));


const states = [
	{
		value: 'New South Wales',
		label: 'New South Wales'
	},
	{
		value: 'Queensland',
		label: 'Queensland'
	},
	{
		value: 'South Australia',
		label: 'South Australia'
	},
	{
		value: 'Tasmania',
		label: 'Tasmania'
	},
	{
		value: 'Victoria',
		label: 'Victoria'
	},
	{
		value: 'Western Australia',
		label: 'Western Australia'
	},
	{
		value: 'Australian Capital Territory',
		label: 'Australian Capital Territory'
	},
	{
		value: 'Northern Territory',
		label: 'Northern Territory'
	}
];


//TODO convert this to use a form library
const OrganisationProfile = () => {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();

	const { organisation } = useValues(organisationlogic);
	const { update, fetch } = useActions(organisationlogic);

	useEffect(() => {
		organisation ?? fetch();
	}, [])// eslint-disable-line

	const [values, setValues] = useState(organisation);

	if (values === null) {
		if (organisation) setValues(organisation);
		return <> </>
	}

	const handleAddress = (key, value) => {
		let new_values = { ...values };
		new_values.address[key] = value;
		setValues(new_values);
	}

	const handlePostal = (key, value) => {
		let new_values = { ...values };
		if (!new_values.postal) {
			new_values.postal = {
				address_line: '',
				suburb: '',
				postcode: '',
				state: ''
			};
		}
		new_values.postal[key] = value;
		setValues(new_values);
	}

	const handleDetails = (key, value) => {
		let new_values = { ...values };
		new_values[key] = value;
		setValues(new_values);
	}

	const handleEnablePostal = (enabled_status) => {
		let new_values = { ...values };
		if (!enabled_status) {
			// console.log('Enabled');
			new_values.postal = {
				address_line: '',
				suburb: '',
				postcode: '',
				state: ''
			};
		} else {
			// console.log('Disabled');
			delete new_values.postal;
		}
		// console.log(new_values);
		setValues(new_values);
	}

	const handleUpdate = () => {
		if (
			values.abn.length !== 11 ||
			!values.name ||
			!values.mobile ||
			!values.landline ||
			!values.address.address_line ||
			!values.address.suburb ||
			!values.address.postcode ||
			!values.address.state
		) {
			enqueueSnackbar('Invalid Form', { variant: 'error' });
			return;
		}
		if (!values.postal_same_as_address) {
			if (
				!values.postal ||
				!values.postal.address_line ||
				!values.postal.suburb ||
				!values.postal.postcode ||
				!values.postal.state
			) {
				enqueueSnackbar('Invalid Form', { variant: 'error' });
				return;
			}
		}
		update(values);
	}

	return (
		<>
			<Card className={classes.root}>
				<CardHeader
					subheader="The information can be edited"
					title="Organisation Details"
				/>
				<Divider />
				<CardContent>
					<Grid
						container
						spacing={3}
					>
						<Grid
							item
							md={6}
							xs={12}
						>
							<TextField
								fullWidth
								label="Organisation Name"
								name="name"
								error={!values?.name ? true : false}
								helperText={!values?.name ? "Invalid" : null}
								onChange={(e) => handleDetails('name', e.target.value)}
								required
								value={values?.name}
								variant="outlined"
								inputProps={{
									maxLength: 100
								}}
							/>
						</Grid>
						<Grid
							item
							md={6}
							xs={12}
						>
							<TextField
								fullWidth
								label="ABN"
								name="abn"
								error={values?.abn?.length !== 11 ? true : false}
								helperText={values?.abn?.length !== 11 ? "Invalid" : null}
								onChange={(e) => handleDetails('abn', e.target.value)}
								required
								value={values?.abn}
								variant="outlined"
								inputProps={{
									maxLength: 11
								}}
							/>
						</Grid>
						<Grid
							item
							md={6}
							xs={12}
						>
							<TextField
								fullWidth
								label="Phone Number"
								required
								name="mobile"
								error={values?.mobile ? false : true}
								helperText={values?.mobile ? null : 'Invalid'}
								onChange={(e) => handleDetails('mobile', e.target.value)}
								value={values?.mobile}
								variant="outlined"
								inputProps={{
									maxLength: 15
								}}
							/>
						</Grid>
						<Grid
							item
							md={6}
							xs={12}
						>
							<TextField
								fullWidth
								label="Landline"
								required
								name="landline"
								error={values?.landline ? false : true}
								helperText={values?.landline ? null : 'Invalid'}
								onChange={(e) => handleDetails('landline', e.target.value)}
								value={values?.landline}
								variant="outlined"
								inputProps={{
									maxLength: 15
								}}
							/>
						</Grid>
						<Grid
							item
							xs={12}
						>
							<Typography>
								Address
							</Typography>
							<Divider />
						</Grid>
						<Grid
							item
							md={6}
							xs={12}
						>
							<TextField
								fullWidth
								label="Street"
								name="address.line"
								error={values?.address?.address_line ? false : true}
								helperText={values?.address?.address_line ? null : 'Invalid'}
								onChange={(e) => handleAddress('address_line', e.target.value)}
								required
								value={values?.address?.address_line}
								variant="outlined"
								inputProps={{
									maxLength: 100
								}}
							/>
						</Grid>
						<Grid
							item
							md={6}
							xs={12}
						>
							<TextField
								fullWidth
								label="Suburb"
								name="address.suburb"
								error={values?.address?.suburb ? false : true}
								helperText={values?.address?.suburb ? null : 'Invalid'}
								onChange={(e) => handleAddress('suburb', e.target.value)}
								required
								value={values?.address?.suburb}
								variant="outlined"
								inputProps={{
									maxLength: 100
								}}
							/>
						</Grid>
						<Grid
							item
							md={6}
							xs={12}
						>
							<TextField
								fullWidth
								label="Postcode"
								name="address.postcode"
								error={values?.address?.postcode ? false : true}
								helperText={values?.address?.postcode ? null : 'Invalid'}
								type='number'
								onChange={(e) => handleAddress('postcode', e.target.value)}
								required
								value={values?.address?.postcode}
								variant="outlined"
								inputProps={{
									maxLength: 4
								}}
							/>
						</Grid>
						<Grid
							item
							md={6}
							xs={12}
						>
							<TextField
								fullWidth
								label="State"
								name="address.state"
								error={values?.address?.state ? false : true}
								helperText={values?.address?.state ? null : 'Invalid'}
								onChange={(e) => handleAddress('state', e.target.value)}
								required
								select
								// SelectProps={{ native: true }}
								value={values?.address?.state}
								variant="outlined"
							>
								{states.map((option) => (
									<MenuItem
										key={option.value}
										value={option.value}
									>
										{option.label}
									</MenuItem>
								))}
							</TextField>
						</Grid>
						<Grid
							item
							xs={12}
						>
							<Typography>
								Postal Address
							</Typography>
							<Divider />
						</Grid>
						<Grid
							item
							md={6}
							xs={12}
						>
							<TextField
								fullWidth
								label="Postal same as above Address"
								name="postal_same_as_address"
								onChange={(e) => {
									handleEnablePostal(e.target.value);
									handleDetails('postal_same_as_address', e.target.value)
								}}
								required
								select
								value={values?.postal_same_as_address}
								variant="outlined"
							>
								<MenuItem
									key={true}
									value={true}
								>
									{'Same as Above'}
								</MenuItem>
								<MenuItem
									key={false}
									value={false}
								>
									{'Use A Different Postal Address'}
								</MenuItem>
							</TextField>
						</Grid>
						{
							(!values?.postal_same_as_address) &&
							<>
								<Grid
									item
									md={6}
									xs={12}
								>
									<TextField
										fullWidth
										label="Street"
										name="postal.line"
										error={values?.postal && values?.postal.address_line ? false : true}
										helperText={values?.postal && values?.postal.address_line ? null : 'Invalid'}
										onChange={(e) => handlePostal('address_line', e.target.value)}
										required
										value={values?.postal ? values?.postal.address_line : ''}
										variant="outlined"
										inputProps={{
											maxLength: 100
										}}
									/>
								</Grid>
								<Grid
									item
									md={6}
									xs={12}
								>
									<TextField
										fullWidth
										label="Suburb"
										name="postal.suburb"
										error={values?.postal && values?.postal.suburb ? false : true}
										helperText={values?.postal && values?.postal.suburb ? null : 'Invalid'}
										onChange={(e) => handlePostal('suburb', e.target.value)}
										required
										value={values?.postal ? values?.postal.suburb : ''}
										variant="outlined"
										inputProps={{
											maxLength: 100
										}}
									/>
								</Grid>
								<Grid
									item
									md={6}
									xs={12}
								>
									<TextField
										fullWidth
										label="Postcode"
										name="postal.postcode"
										error={values?.postal && values?.postal.postcode ? false : true}
										helperText={values?.postal && values?.postal.postcode ? null : 'Invalid'}
										type='number'
										onChange={(e) => handlePostal('postcode', e.target.value)}
										required
										value={values?.postal ? values?.postal.postcode : ''}
										variant="outlined"
										inputProps={{
											maxLength: 4
										}}
									/>
								</Grid>
								<Grid
									item
									md={6}
									xs={12}
								>
									<TextField
										fullWidth
										label="State"
										name="postal.state"
										error={values?.postal && values?.postal.state ? false : true}
										helperText={values?.postal && values?.postal.state ? null : 'Invalid'}
										onChange={(e) => handlePostal('state', e.target.value)}
										required
										select
										value={values?.postal ? values?.postal.state : ''}
										variant="outlined"
									>
										{states.map((option) => (
											<MenuItem
												key={option.value}
												value={option.value}
											>
												{option.label}
											</MenuItem>
										))}
									</TextField>
								</Grid>
							</>
						}
					</Grid>
				</CardContent>
				<Divider />
				<Box
					display="flex"
					justifyContent="flex-end"
					p={2}
				>
					<Button
						color="primary"
						variant="outlined"
						onClick={handleUpdate}
					>
						Save Changes
					</Button>
				</Box>
			</Card>
		</>
	);
};


export default OrganisationProfile;
